import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGbSct = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 5 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "a" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h5v3H0z" }))), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#a)" }, /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "100%", fill: "#005EB8" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0l5 3M0 3L5 0", stroke: "#fff", strokeWidth: 0.6 })));
const ForwardRef = forwardRef(SvgGbSct);
const Memo = memo(ForwardRef);
export default Memo;
